var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { SliderBase } from '@/components/ui/Slider/SliderBase';
import { Text } from '@/components/ui/Typography/Body/Text';
import { sleep } from '@/helpers/common';
export const ThumbnailSlider = (props) => {
    const { children, className, customSetting = {}, isAutoplay, total } = props;
    const sliderRef = useRef(null);
    const [slideIndex, changeSlideIndex] = useState(0);
    const setSliderRef = useCallback((slide) => {
        sliderRef.current = slide;
    }, [sliderRef]);
    // マウスホバー時のオート画像スライド処理
    useEffect(() => {
        let active = true;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const slider = sliderRef.current;
            if (!slider) {
                return;
            }
            // 要素がマウスオーバーされていなければ停止
            if (!isAutoplay) {
                slider.slickPause();
                return;
            }
            yield sleep(1);
            if (active) {
                // 画像の自動スライド再生処理
                slider.slickNext();
                slider.slickPlay();
            }
        }))();
        return () => {
            active = false;
        };
    }, [isAutoplay, sliderRef]);
    const setting = useMemo(() => (Object.assign({ afterChange: changeSlideIndex, arrows: false, autoplay: true, autoplaySpeed: 1000, infinite: true, pauseOnHover: false, slidesToShow: 1, speed: 300, swipeToSlide: false }, customSetting)), [changeSlideIndex, customSetting]);
    return (_jsxs("div", Object.assign({ className: clsx('relative', className) }, { children: [_jsx("div", Object.assign({ className: clsx('thumbnail-slider', 'absolute top-0 right-0 bottom-0 left-0', 'w-full') }, { children: _jsx(SliderBase, Object.assign({ setSliderRef: setSliderRef, setting: setting }, { children: children })) })), total > 1 && isAutoplay && (_jsx("div", Object.assign({ className: clsx('absolute right-12 bottom-12', 'rounded-full', 'flex justify-center items-center', 'bg-black/[0.7]', 'w-[60px] h-[20px]') }, { children: _jsx(Text, Object.assign({ color: 'white', isBold: true, size: 'sm', tagName: 'div' }, { children: `${slideIndex + 1}/${total}` })) })))] })));
};
